'use client';

import { LegacyDialog } from '../../../../../components/dialog';
import {
  UpdateSignalEditForm,
  type UpdateSignalData,
} from '../forms/UpdateSignalEditForm';

export type { UpdateSignalData };

type UpdateSignalEditModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (editedData: UpdateSignalData) => void;
  initialData: UpdateSignalData;
};

export function UpdateSignalEditModal({
  isOpen,
  onClose,
  onSubmit,
  initialData,
}: UpdateSignalEditModalProps) {
  if (!isOpen) return null;

  return (
    <LegacyDialog.Root
      open={isOpen}
      onOpenChange={({ open }) => !open && onClose()}
      lazyMount
      unmountOnExit
    >
      <LegacyDialog.Backdrop />
      <LegacyDialog.Positioner>
        <LegacyDialog.Content
          maxWidth="580px"
          width="90vw"
          maxHeight="90vh"
          overflow="auto"
        >
          <UpdateSignalEditForm
            onClose={onClose}
            onSubmit={onSubmit}
            initialData={initialData}
          />
        </LegacyDialog.Content>
      </LegacyDialog.Positioner>
    </LegacyDialog.Root>
  );
}
